import styled from 'styled-components'

import { Input } from '../../styles/defaults'
import { red, white } from '../../styles/colors'

export const Container = styled.div`
  transition: all 0.5s;
  position: relative;
  width: ${props => props.active ? '300px' : (props.large ? '220px' : '140px')};
`

export const IconContainer = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.15rem;
  height: 1.15rem;

  svg {
    width: 1.15rem;
    height: 1.15rem;
    fill: ${red};
  }
`

export const StyledInput = Input.extend`
  padding-left: 2.5rem;
  background: ${white};
`



// WEBPACK FOOTER //
// ./src/components/SearchInput/styles.js